import "./BoothPreview.scss"
import sign from "./../../assets/sign_2.jpg"
import column from "./../../assets/column_2.jpg"

export interface BoothPreviewProps {
    sign: boolean;
    column: boolean;
    useOvergrowth: boolean;
}

const getImages = (props: BoothPreviewProps) => {
    let elems: any[] = [];

    if(props.sign) {
        elems.push(
            <div className={`Booth-Preview-Entry ${props.useOvergrowth ? '' : 'Overgrowth'}`}>
                <span>SIGN</span>
                <img src={sign} />
            </div>
        )
    }

    if(props.column) {
        elems.push(
            <div className={`Booth-Preview-Entry ${props.useOvergrowth ? '' : 'Overgrowth'}`}>
                <span>COLUMN</span>
                <img src={column} />
            </div>
        )
    }

    return elems;
}

const BoothPreview = (props: BoothPreviewProps) => {
    if(props.useOvergrowth) {
        return (
            <div className="Booth-Preview">
                {getImages(props)}
            </div>
        )
    } else {
        return (
            <div className="Booth-Preview" style={{width: "70%"}}>
                <div style={{width: "90%", display: "flex"}}>
                    {getImages(props)}
                </div>
            </div>
        )
    }
}

export default BoothPreview;
